import React, { Component } from 'react';
import PropTypes from 'prop-types';
import StylePropType from 'react-style-proptype';
import Radium from 'radium';
import Styles from './MapImage.styles';

class MapImage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoaded: false,
    };

    this.onImageLoaded = this.onImageLoaded.bind(this);
  }

  onImageLoaded(event) {
    this.setState({ isLoaded: true });
    this.props.onLoad(event);
  }

  render() {
    const { imageUrl, imageWidth, imageHeight, alt = '', style = {} } = this.props;
    const loadedStyle = this.state.isLoaded ? Styles.imageLoaded : {};
    const imageStyle = { ...Styles.imageStyle(imageWidth, imageHeight), ...style, ...loadedStyle };
    return (
      <div style={imageStyle}>
        <img style={imageStyle} src={imageUrl} onLoad={this.onImageLoaded} alt={alt} />
        {this.props.children}
      </div>
    );
  }
}
MapImage.defaultProps = {
  style: {},
  imageWidth: null,
  imageHeight: null,
  alt: '',
};

MapImage.propTypes = {
  imageUrl: PropTypes.string.isRequired,
  style: StylePropType,
  onLoad: PropTypes.func,
  imageWidth: PropTypes.number,
  imageHeight: PropTypes.number,
  alt: PropTypes.string,
};

export default Radium(MapImage);



// WEBPACK FOOTER //
// ./src/components/Map/MapImage/MapImage.js